import { useEffect } from 'react';
import { useRouter } from 'next/router';
// Hooks
import { useCookies } from '@/hooks/useCookies';

function ToStore() {
  const router = useRouter();
  const { handleSetReferral } = useCookies();
  useEffect(() => {
    if (router.isReady) {
      // Gets referral data and redirects to store/all
      handleSetReferral();
    }
  }, [router.isReady]);

  return <div></div>;
}

export default ToStore;
